// extracted by mini-css-extract-plugin
export default {"section2":"section2_section2__0advp","content_box":"section2_content_box__cQ+-j","title1":"section2_title1__Xzj6T","hero_title1":"section2_hero_title1__JWU2t"};